import axios from "axios";
import { useDispatch } from "react-redux";
import { loadingEnd, loadingStart } from "store/actions";
/**
 *
 * @User : 백욱진
 * @Date : 2023.05.15
 * @file : api/indx.js
 * @Desc : api RESTful API 호출부
 */

const defaultConfig = {
  // 여기에 기본 설정을 추가하세요.
  headers: {
    "Content-Type": "application/json",
  },
};
export const post = async (url, param, config) => {
  const mergedConfig = { ...defaultConfig, ...config };
  return axios.post(url, param, mergedConfig);
};

export const useExtSubmission = () => {
  const dispatch = useDispatch();

  const extSubmission = async (url, param = {}, callback, loadingYn = "Y") => {
    try {
      loadingYn === "Y" && dispatch(loadingStart());
      const { data } = await post(url, param);
      if (data?.ERRCODE || data?.ERRMSG) {
        alert(`${data.ERRMSG}`);
        if(data?.ERRCODE === "SYS-00000"){
          window.location.replace('/portal/main/index.do')
        }
        return false;
      }
      if (callback) callback(null, data);
      return data;
    } catch (e) {

      if (callback) callback(e, null);
      //alert(`요청중 오류가 발생하였습니다.`);
    } finally {
      loadingYn === "Y" && dispatch(loadingEnd());
    }
  };

  return extSubmission;
};
